var map = {
	"./Dr.A.Tamilarasi.jpg": 85432,
	"./Dr.K.Chitra.jpg": 73158,
	"./Dr.L.Rahunathan.jpg": 54138,
	"./Dr.M.Jagadeesan.jpg": 13266,
	"./Dr.M.Pyingkodi.jpg": 32145,
	"./Dr.P.Vijayakumar.jpg": 2558,
	"./Dr.T.Kavitha.jpg": 2516,
	"./Mr.S.B.Karthikeyan.jpg": 66545,
	"./Ms.K.Jeeva dharshini.jpg": 55236,
	"./Ms.M.Sindhu.jpg": 46248,
	"./Ms.S.Hemalatha.jpg": 65874,
	"./Ms.T.Kalpana.jpg": 48700,
	"./dharanisri.jpg": 72781
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24652;